import { render, staticRenderFns } from "./BookEditAppearanceTab.vue?vue&type=template&id=22f38d3d"
import script from "./BookEditAppearanceTab.vue?vue&type=script&lang=js"
export * from "./BookEditAppearanceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports